import { IDateTimeType } from '@connect-soft/date-helper';
import { LocalizationProvider as MuiLocalizationProvider, LocalizationProviderProps } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

type IProps<TDate extends IDateTimeType, TLocal> = Omit<LocalizationProviderProps<TDate, TLocal>, 'dateAdapter'>;

const FormLocalizationProvider = (props: IProps<IDateTimeType, string>) => {
    return <MuiLocalizationProvider dateAdapter={AdapterDayjs} {...props} />;
};

export default FormLocalizationProvider;
